import{e as n}from"./chunk-KTUPMIFX.js";import{a as r}from"./chunk-BJLACGZ2.js";import{m as o}from"./chunk-HBP5N4FR.js";o();function f(e){let c=r.getState(),t=n(c);return e?t&&!isNaN(t)?Math.max(t,e.nonce):e.nonce:t}export{f as a};
//# sourceMappingURL=chunk-2LFAG5UW.js.map
